module.exports = __webpack_public_path__ + "static/media/why-us-bg.a1dd7fc2.jpg";